"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _core = require("@material-ui/core");

var styles = function styles(theme) {
  return {
    root: {
      color: theme.palette.text.primary
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);
/**
 * Provides label for a control.
 */

var FormLabel = function FormLabel(_ref) {
  var children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_core.FormLabel, {
    className: classes.root
  }, children);
};

FormLabel.propTypes = {
  /** The content of the component. */
  children: _propTypes["default"].node.isRequired
};
var _default = FormLabel;
exports["default"] = _default;